<template>
  <div id="main-content" class="parent-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row :gutter="10">
        <el-col :span="12" :xs="24" :md="14">
          <div class="d-flex align-items-center pl-2">
            <span class="label-search">{{$t('log.search')}}</span>
            <input @change="onGetListLogs" type="text" v-model="searchText" class="input-search-log" :placeholder="$t('log.placeholder')">
          </div>
        </el-col>
        <el-col :span="8" :xs="24" :md="10" class="text-left">
          <el-radio-group @change="onGetListLogs" v-model="filters.exception" class="radio-custom">
            <el-radio :label="null" border>{{$t('log.status.all')}}</el-radio>
            <el-radio :label="1" border>{{$t('log.status.error')}}</el-radio>
            <el-radio :label="0" border>{{$t('log.status.success')}}</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mt-2">
        <el-col :span="16" :xs="24" :md="20">
          <div class="d-flex align-items-center pl-2">
            <span class="label-search">{{$t('log.time')}}</span>
            <div class="form-date">
              <el-date-picker
                  v-model="filters.start_created_at" value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime">
              </el-date-picker>
              <span class="icon-space">~</span>
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="filters.end_created_at"
                  type="datetime">
              </el-date-picker>
            </div>
            <div class="btn-search-time">
              <el-button @click="onGetListLogs"  type="success"> <i class="el-icon-search"></i> {{ $t('log.btnSearch') }}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="total-item">
        <span class="total-item__total">{{$t('log.totalItem', {field: dataPage.total})}}</span>
        <el-button @click="onExportData"  type="primary" size=""> <i class="el-icon-document"></i> {{ $t('log.btnExport') }}</el-button>
      </div>
      <el-row>
        <el-col :span="24">
            <table class="bus-list mt-2">
              <tr>
                <th width="5%">#</th>
                <th width="15%" >
                  <div class="input-th1">
                    <span>{{ $t('log.timeLog') }}</span>
                    <Sort :model="sort.created_at" @change="changeSort($event, 'created_at')"></Sort>
                  </div>
                </th>
                <th width="15%" >
                  <div class="input-th1">
                    <span>{{ $t('log.user') }}</span>
                    <Sort :model="sort.created_user" @change="changeSort($event, 'created_user')"></Sort>
                  </div>
                </th>
                <th width="7%" >{{ $t('log.isError') }}</th>
                <th width="20%" >
                  {{$t('log.module')}}
                </th>
                <th width="15%" >
                  <el-select style="width: 95%" v-model="filters.action" :placeholder="$t('log.action')">
                    <el-option v-for="item in listActions" :key="item.value" :label="$t(`log.action.${item.name}`)" :value="item.value"></el-option>
                  </el-select>
                </th>
                <th width="20%">
                    <el-select style="width: 95%" v-model="filters.device" :placeholder="$t('log.device')">
                      <el-option v-for="item in listDrive" :key="item.id" :label="$t(`log.drivers.${item.name}`)" :value="item.id"></el-option>
                    </el-select>
                </th>
                <th>
                  {{ $t('log.note') }}
                </th>
              </tr>
              <tbody>
              <tr v-for="(item, index) in listLogs" :key="index">
                <td scope="row" width="5%">{{ (dataPage.current_page -1)*dataPage.limit + index+1}}</td>
                <td>
                  <div v-if="item.created_at">
                    <div>{{formatDateTime('YYYY/MM/DD', item.created_at)}}</div>
                    <div>{{formatDateTime('(dddd)', item.created_at)}}</div>
                    <div>{{formatDateTime('HH:mm:ss', item.created_at)}}</div>
                  </div>
                </td>
                <td>{{item.created_user}}</td>
                <td>{{item.is_exception ? $t('log.statusError.yes') :$t('log.statusError.no')}}</td>
                <td>{{item.name}}</td>
                <td>{{item.action}}</td>
                <td>
                  <div class="text-left text-drive">{{item.user_agent}}</div>
                </td>
                <td>
                  <div class="text-note-log">{{item.exception_trace}}</div>
                </td>
              </tr>
              </tbody>
            </table>
        </el-col>
      </el-row>
      <el-row style="padding-top: 15px">
        <el-pagination
            background v-show="dataPage.total"
            @current-change="didSelectPage"
            :page-size="dataPage.limit"
            layout="prev, pager, next"
            :current-page="page"
            :total="dataPage.total">
        </el-pagination>
      </el-row>
    </el-col>
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
import Sort from "@/components/Sort"
import {formatDateTime} from "@/utils";
export  default {
  components: {
    PageTitle,
    Sort
  },
  data(){
    return {
      title: 'log.titleList',
      backLink: '',
      page:1,
      dataPage :  {
        limit: 10
      },
      listLogs: [],
      searchText: '',
      status: 0,
      filters:{
        device: null,
        action:null,
        start_created_at:null,
        end_created_at:null,
        exception: null
      },
      sort: {
        created_at: 'desc',
        created_user:null
      },

    }
  },
  computed:{
    listDrive(){
      return [
        {id: null, name:'all'},
        {id: 1, name:'ios'},
        {id: 2, name:'android'},
        {id: 0, name:'web'}
      ]
    },
    listActions(){
      return [
        {value: null , name: 'all'},
        {value: 'create' , name: 'create'},
        {value: 'update' , name: 'update'},
        {value: 'save' , name: 'save'},
        {value: 'delete', name: 'delete'},
        {value: 'approve' , name: 'approve'},
        {value: 'reject' , name: 'reject'},
        {value: 'send_mail' , name: 'send_mail'},
      ]
    },
    lang(){
      return this.$i18n.locale || null
    }
  },
  created() {
    this.onGetListLogs()
  },
  watch:{
    filters: {
      deep: true,
      handler: function () {
        this.page = 1
        clearTimeout(this.filterTimeout)
        this.filterTimeout = setTimeout(() => {
          this.onGetListLogs()
        }, 500)

      }
    },
    lang(){
      this.onGetListLogs()
    }
  },
  methods:{
    changeSort(type, field){
      this.sort[field] = type
      this.sort = Object.assign({}, this.sort)
      this.onGetListLogs()
    },
    formatDateTime(param, value){
      return formatDateTime(param, value)
    },
    onGetListLogs(){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.listLogs = response.data.data.data_list
            this.dataPage = response.data.data
          }
        },
        errorCallback: () => {},
        sort: this.sort,
        search: this.searchText,
        filter: this.filters,
        page: this.page,
        lang: this.lang
      }
      this.$store.dispatch('logs/getListLogs', payload)
    },
    onExportData(){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            const url = URL.createObjectURL(new Blob([response.data], { type: ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet ' }))
            const link = document.createElement('a')
            link.href = url
            link.download = `log_${formatDateTime('YYYYMMDD_HHmmss', new Date())}.csv`
            document.body.appendChild(link)
            link.click()
          }
        },
        errorCallback: () => {},
        sort: this.sort,
        search: this.searchText,
        filter: this.filters,
        page: this.page,
        lang: this.lang
      }
      this.$store.dispatch('logs/getFileExport', payload)
    },
    didSelectPage: function (e) {
      this.page = e
      this.onGetListLogs()
    },
  }
}
</script>
<style lang="scss">
.input-th1{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98%;
}
@mixin excerpt($font-size: 13px, $line-height: 1.4, $lines-to-show: 3, $excerpt-bg: transparent) {
  background: $excerpt-bg;
  display: -webkit-box;
  font-size: $font-size;
  line-height: $line-height;
  -webkit-line-clamp: $lines-to-show;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.input-search-log {
  width: 80%;
  margin-left: 1rem;
  height: 40px;
  font-size: .95rem;
  border-radius: 4px;
  padding-left: .3rem;
  border:1px solid #2b2b2a;
  &:focus-visible{
    outline: none;
  }
}
.radio-custom{
  .el-radio__inner{
    border-radius: 0;
    border: 1px solid #343232
  }
  .el-radio{
    border: 1px solid #343232 !important;
    color: #000000;
    font-weight: 500;
    margin-right: 1rem;
  }
  .el-radio__input.is-checked{
    + {
      .el-radio__label{
        color: #000000;
        font-weight: 600;
      }
    }
  }
}
.form-date{
  margin-left: .9rem;
  .el-date-editor{
    input{
      border: 1px solid #343232 ;
      border-radius: 4px;
      font-size: 1rem;
    }
  }
  .icon-space{
    margin: 0 1rem;
    font-weight: bold;
    font-size: 1.1rem;
  }
}
.btn-search-time{
  margin-left: 1.5rem;
}
.total-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top:1rem ;
  padding: 0 .5rem;
  &__total{
    font-weight: 600;
    display: block;
    margin-bottom: -10px;
  }
}
.text-note-log{
  @include excerpt(16px, 1.3, 4);
  max-width: 150px;
  text-align: left;
}
.text-drive{
  width: 100%;
  max-width: 200px;
  @include excerpt(16px, 1.3, 4);
}
</style>
